import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

export const subscriptionsPath = "/subscriptions";

export const planConfigurationPath = urlJoin(subscriptionsPath, "plan-configuration");
export const planConfigurationUrl = planConfigurationPath;

export const planConfigurationDetailsPath = (id: string) => urlJoin(planConfigurationPath, id);

export const planConfigurationDetailsUrl = (id: string, params?: Record<string, string>) =>
  planConfigurationDetailsPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
